import { PureComponent } from 'react';
import * as styles from './styles';
import CustomModal from 'components/CustomModal';

const customStyles = {
  content : {
    width: '433px'
  }
};


export default class PaymentModal extends PureComponent {
  render () {
    let { isOpen, closeModal, i18n, blockPatient, profile } = this.props;

    return (
      <CustomModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <styles.ModalCloseIcon onClick={closeModal}/>
        <styles.ModalTitle>{i18n.t('confirmation_blocking_popup_title')}</styles.ModalTitle>
        <styles.ModalText>{i18n.t('confirmation_blocking_popup_text')}</styles.ModalText>
        <styles.ModalLine />
        <div style={{ position: 'relative', textAlign: 'right' }}>
          <styles.ModalCancel onClick={closeModal}>{i18n.t('popup_cancel_button')}</styles.ModalCancel>
          <styles.ModalButtonConfirm onClick={() => { blockPatient(profile.umbi.id, profile.id); closeModal(); }}>
            {i18n.t('block_patient_button')}
          </styles.ModalButtonConfirm>
        </div>
      </CustomModal>
    );
  }
}
